import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as UserProfileIcon } from "../assets/icons/user_profile.svg";
import EntryLogo from "../assets/images/EntryLogo.png";
import i18next from "i18next";
import { Select } from "antd";
import { useTranslation } from "react-i18next";

// Dil kodlarını görüntülenen etiketlere eşleme
const languageMap = {
  'en': 'Eng',
  'az': 'Aze',
  'ru': 'Ru',
  'en-US': 'Eng'
};

const HeaderMainPage = ({ title, showProfile, backwardNavigate }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language || localStorage.getItem('i18nextLng') || 'az');
  
  // Görüntülenecek dil etiketini al
  const getDisplayLanguage = (langCode) => {
    return languageMap[langCode] || langCode;
  };
  
  const toggleLang = (lang) => {
    // Eğer tam dil kodu gelirse (en-US gibi), sadece ana dil kodunu al (en)
    const mainLangCode = lang.split('-')[0];
    i18next.changeLanguage(mainLangCode);
    setCurrentLang(mainLangCode);
    localStorage.setItem('i18nextLng', mainLangCode);
  };
  
  useEffect(() => {
    // Mevcut dili al ve state'i güncelle
    const storedLang = localStorage.getItem('i18nextLng');
    if (storedLang && storedLang !== currentLang) {
      setCurrentLang(storedLang);
    }
    
    // Dil değişikliğini dinle
    const handleLanguageChange = (lng) => {
      console.log('Dil değişti:', lng);
      setCurrentLang(lng);
    };
    
    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n, currentLang]);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  const handleProfileClick = () => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/account");
    } else {
      navigate("/signup");
    }
  };

  return (
    <header className="mt-3 d-flex align-items-center justify-content-between mb-3">
      <Link to={backwardNavigate ? backwardNavigate : "/"} className="logo">
        <img src={EntryLogo} alt="eprorab logo" style={{ height: "40px" }} />
      </Link>
      <div className="d-flex align-items-center">
        <Select
          className="language--change"
          value={getDisplayLanguage(currentLang)}
          style={{
            width: 60,
          }}
          onChange={(value) => toggleLang(value)}
          options={[
            {
              value: "en",
              label: "Eng",
            },
            {
              value: "az",
              label: "Aze",
            },
            {
              value: "ru",
              label: "Ru",
            },
          ]}
        />
        {showProfile ? (
          <div 
            style={{ cursor: "pointer" }}
            onClick={handleProfileClick}
          >
            <UserProfileIcon />
          </div>
        ) : (
          <div className="ms-4"></div>
        )}
      </div>
    </header>
  );
};

export default HeaderMainPage;
